import { useCompanyInfo } from '../contexts/CompanyInfoContext';
import { getMediaUrl } from '../utils/mediaUrl';

const SITE_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Hook that provides structured data fragments built from company_info.
 * Used by all pages that embed JSON-LD schema markup.
 */
export const useSchemaOrg = () => {
  const info = useCompanyInfo();
  const address = info?.address || {};
  const contact = info?.contact || {};
  const coords = info?.coordinates || {};
  const name = info?.company_name || 'Sand-tec AS';
  const phone = contact.phone || '';
  const email = contact.email || '';
  const logoPath = info?.logo;
  // For display: use getMediaUrl (adds REACT_APP_BACKEND_URL)
  const logoUrl = logoPath ? getMediaUrl(logoPath) : '';
  // For schema: use absolute production URL
  const schemaLogoUrl = logoPath ? (() => {
    const display = getMediaUrl(logoPath);
    if (display.startsWith('http')) return display;
    return `${SITE_URL}${display}`;
  })() : '';

  /** Reusable Organization/AutoRepair reference */
  const organization = {
    "@type": "AutoRepair",
    "@id": `${SITE_URL}/#organization`,
    "name": name,
    ...(schemaLogoUrl ? { "logo": schemaLogoUrl } : {}),
  };

  /** Full PostalAddress object */
  const postalAddress = {
    "@type": "PostalAddress",
    "streetAddress": address.street || '',
    "addressLocality": address.city || '',
    "postalCode": address.postal_code || '',
    "addressCountry": "NO",
  };

  /** Publisher block for WebPage schemas */
  const publisher = {
    ...organization,
    "address": postalAddress,
    "telephone": phone,
    ...(email ? { "email": email } : {}),
  };

  /** GeoCoordinates (if available) */
  const geo = coords.lat && coords.lng ? {
    "@type": "GeoCoordinates",
    "latitude": coords.lat,
    "longitude": coords.lng,
  } : null;

  /** Formatted address string for noscript blocks */
  const addressLine = `${name} — ${address.street || ''}, ${address.postal_code || ''} ${address.city || ''} — Tlf: ${phone}`;

  return { name, phone, email, logoUrl, organization, postalAddress, publisher, geo, addressLine, SITE_URL };
};
